import { render, staticRenderFns } from "./preplanPortal.vue?vue&type=template&id=bf5f3434&scoped=true"
import script from "./preplanPortal.vue?vue&type=script&lang=js"
export * from "./preplanPortal.vue?vue&type=script&lang=js"
import style0 from "./preplanPortal.vue?vue&type=style&index=0&id=bf5f3434&prod&lang=css"
import style1 from "./preplanPortal.vue?vue&type=style&index=1&id=bf5f3434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5f3434",
  null
  
)

export default component.exports